import React, { Component, Fragment } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import { UserInspector, withMe } from "pobble-components/dist/pobble-user";
import PageNotFound from "pobble-components/dist/page-not-found";
import EnvironmentLine from "pobble-components/dist/environment-line";
import Header from "pobble-components/dist/pobble-header";

import Search from "./Search";
import Global from "./Global";
import Work from "../work/Work";
import LessonBarHolder from "./LessonBarHolder";
import { SubscriptionProvider } from "pobble-components/dist/subscriptions";

class SearchApp extends Component {
  render() {
    const { me } = this.props;
    let page = window.location.pathname.split("/")[2];
    return (
      <SubscriptionProvider>
        <div className={me && me.account.student_type ? "user--student" : ""}>
          <EnvironmentLine />
          <div className="header__wrapper">
            <Header activePage="pobble-app" />
          </div>
          <LessonBarHolder
            isTeacher={
              me &&
              me.account &&
              me.account.policy &&
              me.account.policy.create_lesson
            }
          />
          <UserInspector>
            <Router>
              <Switch>
                {/*<Route path='/' exact component={Search} />*/}
                <Route path="/" exact component={Global} />

                <Route path="/search" exact component={Search} />
                <Route path="/search/:query" exact component={Search} />
                <Route path="/schools/:schoolId" exact component={Search} />
                <Route path="/students/:studentId" exact component={Search} />
                <Route
                  path="/search/:query/school/:schoolId"
                  exact
                  component={Search}
                />
                <Route
                  path="/search/:query/students/:studentId"
                  exact
                  component={Search}
                />
                <Route path="/groups/:groupId" exact component={Search} />
                <Route path="/works/:workId" exact component={Work} />
                <Route
                  path="/search/resource/:resourceId"
                  exact
                  component={Search}
                />
                <Route component={PageNotFound} />
              </Switch>
            </Router>
          </UserInspector>
        </div>
      </SubscriptionProvider>
    );
  }
}

export default withMe(SearchApp);



// WEBPACK FOOTER //
// ./components/search/SearchApp.js